import { useState } from 'react';
import reportIcon from '~/assets/icons/report.svg';
import sortIcon from '~/assets/icons/sort.svg';
import { CurrencyIcon } from '~/components/collections/CurrencyIcon';
import { Divider } from '~/components/ui/Divider';
import { Text } from '~/components/ui/Text';
import { useWalletIcon } from '~/hooks';
import { Currency } from '~/shared';
import { Select } from '../Select';
import { sortSelectItems } from './AppMyBusinessReports.model';
import {
	StyledContainer,
	StyledHeadContainer,
	StyledHeadLeftContainer,
	StyledHeadRightContainer,
	StyledMoneyValueContainer,
	StyledTable,
	StyledTableWrapper,
	StyledTd,
	StyledTh,
	StyledTr,
} from './AppMyBusinessReports.styled';

const mockRows = Array.from({ length: 20 }, (_, i) => ({
	id: i,
	name: 'Топливо АИ - 92',
	time: '20:08',
	date: '05.01.25',
	purchase: i * 1000,
	price: 450,
	tax: 450,
	profit: 450,
}));

const AppMyBusinessReports = () => {
	const [sortValue, setSortValue] = useState<string | number | null>(null);
	const rubleIcon = useWalletIcon(Currency.Ruble, true);

	return (
		<StyledContainer>
			<StyledHeadContainer>
				<StyledHeadLeftContainer>
					<img src={reportIcon} />
					<Text>Отчеты</Text>
				</StyledHeadLeftContainer>
				<StyledHeadRightContainer>
					<Select
						items={sortSelectItems}
						value={sortValue}
						placeholder={'Сортировать'}
						onChange={(value) => {
							setSortValue(value.value);
						}}
						icon={sortIcon}
					/>
				</StyledHeadRightContainer>
			</StyledHeadContainer>
			<Divider
				$direction={'H'}
				style={{ opacity: 0.1, marginTop: 20, marginBottom: 8 }}
			/>

			<StyledTableWrapper>
				<StyledTable>
					<thead>
						<tr>
							<StyledTh>
								<Text>Название товара</Text>
							</StyledTh>
							<StyledTh>
								<Text>Дата</Text>
							</StyledTh>
							<StyledTh>
								<Text>Закупка</Text>
							</StyledTh>
							<StyledTh>
								<Text>Цена</Text>
							</StyledTh>
							<StyledTh>
								<Text>Налог</Text>
							</StyledTh>
							<StyledTh>
								<Text>Прибыль</Text>
							</StyledTh>
						</tr>
					</thead>
					<tbody>
						{mockRows.map((row) => (
							<StyledTr key={row.id}>
								<StyledTd>
									<Text style={{ fontWeight: 500 }}>{row.name}</Text>
								</StyledTd>
								<StyledTd>
									<Text style={{ whiteSpace: 'nowrap' }}>
										<span style={{ fontWeight: 500 }}>{row.time}</span>{' '}
										<span style={{ opacity: 0.5 }}>{row.date}</span>
									</Text>
								</StyledTd>
								<StyledTd>
									<StyledMoneyValueContainer>
										<CurrencyIcon
											icon={rubleIcon}
											size="sm"
											asMask
											color="#3491E9"
										/>
										<Text>{row.purchase.toLocaleString('ru-RU')}</Text>
									</StyledMoneyValueContainer>
								</StyledTd>
								<StyledTd>
									<StyledMoneyValueContainer>
										<CurrencyIcon
											icon={rubleIcon}
											size="sm"
											asMask
											color="#3491E9"
										/>
										<Text>{row.price.toLocaleString('ru-RU')}</Text>
									</StyledMoneyValueContainer>
								</StyledTd>
								<StyledTd>
									<StyledMoneyValueContainer>
										<CurrencyIcon
											icon={rubleIcon}
											size="sm"
											asMask
											color="#3491E9"
										/>
										<Text>{row.tax.toLocaleString('ru-RU')}</Text>
									</StyledMoneyValueContainer>
								</StyledTd>
								<StyledTd>
									<StyledMoneyValueContainer>
										<Text style={{ color: '#77DE38' }}>+</Text>
										<CurrencyIcon
											icon={rubleIcon}
											size="sm"
											asMask
											color="#77DE38"
										/>
										<Text style={{ color: '#77DE38' }}>
											{row.profit.toLocaleString('ru-RU')}
										</Text>
									</StyledMoneyValueContainer>
								</StyledTd>
							</StyledTr>
						))}
					</tbody>
				</StyledTable>
			</StyledTableWrapper>
		</StyledContainer>
	);
};

export { AppMyBusinessReports };
